import React from 'react';
import { A } from '../../hybrid/wrappers';
import { navigateV2 } from '../../common/utils/router';
import { useWindowDimensions } from '../../common/utils/windowDimensions';
import classnames from 'classnames';

const Breadcrumbs = ({ compStyles, breadcrumbs }) => {
    const screenWidth = useWindowDimensions() < 768;
    return breadcrumbs?.length ? (
        <div className={classnames(compStyles.blockXl, compStyles.breadcrumb)}>
            {!screenWidth ? (
                breadcrumbs.map((bread, idx) => (
                    <A
                        key={`bread${idx}`}
                        href={`${bread.link || ''}`}
                        onClick={(e) => {
                            if (bread?.onClick) {
                                e.preventDefault();
                                bread.onClick();
                                return;
                            }
                            if (!e.ctrlKey) {
                                e.preventDefault();
                            }
                            navigateV2(bread.link);
                        }}
                        className={
                            breadcrumbs.length > idx + 1
                                ? classnames(compStyles.breadItem, compStyles.breadItemActive)
                                : compStyles.breadItem
                        }
                    >
                        <div
                            className={
                                idx > 1
                                    ? classnames(compStyles.breadItemTitle, compStyles.breadItemTitleLong)
                                    : compStyles.breadItemTitle
                            }
                        >
                            {bread.title}
                        </div>
                        <div>
                            {breadcrumbs.length > idx + 1 && (
                                <div
                                    style={{
                                        width: '6px',
                                        height: '6px',
                                        background: 'rgba(230, 230, 230, 1)',
                                        borderRadius: '50%',
                                        margin: '0 12px'
                                    }}
                                ></div>
                            )}
                        </div>
                    </A>
                ))
            ) : (
                <A
                    href={`${breadcrumbs?.[breadcrumbs.length - 2]?.link || ''}`}
                    onClick={(e) => {
                        if (breadcrumbs?.[breadcrumbs.length - 2]?.onClick) {
                            e.preventDefault();
                            breadcrumbs?.[breadcrumbs.length - 2]?.onClick();
                            return;
                        }
                        if (!e.ctrlKey) {
                            e.preventDefault();
                        }
                        navigateV2(breadcrumbs[breadcrumbs.length - 2].link);
                    }}
                    className={compStyles.breadItem}
                >
                    <div>
                        {/* {svgSprite('angle-left', {
                            fill: 'var(--greySuperDarkColor)',
                            width: '4px',
                            height: '8px'
                        })} */}
                        <div
                            style={{
                                width: '6px',
                                height: '6px',
                                background: 'rgba(230, 230, 230, 1)',
                                borderRadius: '50%',
                                margin: '0 12px'
                            }}
                        ></div>
                    </div>
                    <div className={compStyles.breadItemTitle}>{breadcrumbs[breadcrumbs.length - 2].title}</div>
                </A>
            )}
        </div>
    ) : (
        <></>
    );
};
export default Breadcrumbs;
